import React from 'react';
import { Link } from "react-router-dom";
import './JobEdit.css';

export class JobList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: "",
      jobs: [],
    };
    // Binding this keyword 
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentDidMount();
  }

  async componentDidMount() {
    if (this.state.jobs.length < 1) {
      // GET request using fetch with async/await
      const response = await fetch('/jobs');
      const data = await response.json();
      this.setState(data);
    }
  }

  render() {
    const jobList = this.state.jobs.map((job, i) => {
      return (
        <div className='field-slot' key={i}>
          <Link to={'/jobs/'+job.jobName}>{job.jobName}</Link>
          <p>{job.url}</p>
        </div>
      )
    });
    return (
      <div className="App">
        <div className="container">
          <div className="row">
            <div className="col-md-8 mx-auto job">
              <h3>Jobs</h3>
              <Link className="btn btn-outline-success" to="/jobs/new" role="button">Create New</Link>
              {jobList}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default JobList;
